/* Gymatics cart drawer R2 behaviour: assurance tiles, order note, open choreography, count/total bump.
   Styles: assets/gymatics-premium-cart.css. Loaded from snippets/gymatics-delivery-progress.liquid. */
(function () {
  if (window.__gmPremiumCart) return;
  window.__gmPremiumCart = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tile(label, path) {
    return '<li class="gc-assure__item"><span class="gc-assure__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24">' + path + '</svg></span>' + label + '</li>';
  }
  var ASSURE_HTML =
    '<ul class="gc-assure" aria-label="Shopping with Gymatics">' +
    tile('Secure checkout', '<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>') +
    tile('Made in Wales', '<path d="M12 21s-7-4.4-9.3-9A5 5 0 0 1 12 6a5 5 0 0 1 9.3 6c-2.3 4.6-9.3 9-9.3 9Z"/>') +
    tile('Free local collection', '<path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/>') +
    '</ul>';

  // One set of tiles, placed above the buttons. The theme re-renders the drawer after every
  // cart change, so this runs again from the observer: add if missing, drop duplicates.
  function ensureAssure(drawer) {
    var footer = drawer.querySelector('.cart-drawer__footer');
    if (!footer) return;
    var sets = drawer.querySelectorAll('.gc-assure');
    for (var i = 1; i < sets.length; i++) sets[i].parentNode.removeChild(sets[i]);
    if (!sets.length) footer.insertAdjacentHTML('beforeend', ASSURE_HTML);
    // R1 strip, if a cached page still has it
    var old = drawer.querySelectorAll('.gm-trust');
    for (var j = 0; j < old.length; j++) old[j].parentNode.removeChild(old[j]);
  }

  // Order note: clearer copy, example placeholder, "Note added" chip and a Saving/Saved state.
  // The theme's <cart-note> element already saves the note to the cart as the customer types.
  var NOTE_PLACEHOLDER = 'e.g. It’s a gift, please don’t include the receipt. Or: leave with a neighbour if we’re out.';
  function enhanceNote(drawer) {
    var details = drawer.querySelector('#Details-CartDrawer');
    var area = drawer.querySelector('#CartDrawer-Note');
    if (!details || !area || details.__gcNote === area) return;
    details.__gcNote = area; // the drawer is re-rendered after cart changes, so key this on the textarea

    var title = details.querySelector('.summary__title');
    if (title && !title.querySelector('.gc-note__text')) {
      var caret = title.querySelector('svg');
      title.textContent = '';
      title.insertAdjacentHTML('beforeend',
        '<span class="gc-note__text"><span>Add an order note</span><small>Gift message or delivery notes</small></span>' +
        '<span class="gc-note__chip">Note added</span>');
      if (caret) title.appendChild(caret);
    }
    area.setAttribute('placeholder', NOTE_PLACEHOLDER);
    area.setAttribute('aria-label', 'Order note');

    var field = area.closest('.cart__note') || area.parentNode;
    var status = field.querySelector('.gc-note__status');
    if (!status) {
      field.insertAdjacentHTML('beforeend',
        '<div class="gc-note__status" aria-live="polite"><span class="gc-note__state"></span><span class="gc-note__count"></span></div>');
      status = field.querySelector('.gc-note__status');
    }
    var state = status.querySelector('.gc-note__state');
    var count = status.querySelector('.gc-note__count');

    function refresh() {
      var len = area.value.trim().length;
      details.classList.toggle('gc-has-note', len > 0);
      count.textContent = len ? area.value.length + ' characters' : '';
    }
    var timer;
    area.addEventListener('input', function () {
      refresh();
      state.textContent = 'Saving…';
      state.className = 'gc-note__state is-on';
      clearTimeout(timer);
      timer = setTimeout(function () {
        state.textContent = 'Saved';
        state.className = 'gc-note__state is-on is-saved';
        timer = setTimeout(function () { state.className = 'gc-note__state is-saved'; }, 2200);
      }, 900);
    });
    refresh();
    if (area.value.trim()) details.open = true;
  }

  function text(drawer, sel) {
    var el = drawer.querySelector(sel);
    return el ? el.textContent.trim() : '';
  }

  function bump(drawer, sel) {
    if (reduceMotion) return;
    var el = drawer.querySelector(sel);
    if (!el) return;
    el.classList.remove('gc-bump');
    void el.offsetWidth; // restart the animation
    el.classList.add('gc-bump');
  }

  function playOpen(drawer) {
    if (reduceMotion) return;
    drawer.classList.remove('gc-open');
    void drawer.offsetWidth;
    drawer.classList.add('gc-open');
    clearTimeout(drawer.__gcOpenTimer);
    drawer.__gcOpenTimer = setTimeout(function () {
      drawer.classList.remove('gc-open');
    }, 1900);
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    ensureAssure(drawer);
    enhanceNote(drawer);
    var COUNT = '.drawer__heading .totals__items';
    var TOTAL = '.totals__total-value';
    var lastCount = text(drawer, COUNT);
    var lastTotal = text(drawer, TOTAL);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.target === drawer && m.attributeName === 'class') {
          var wasActive = (m.oldValue || '').split(/\s+/).indexOf('active') !== -1;
          if (drawer.classList.contains('active') && !wasActive) playOpen(drawer);
        }
      }
      ensureAssure(drawer);
      enhanceNote(drawer);
      var c = text(drawer, COUNT);
      if (c !== lastCount) { lastCount = c; bump(drawer, COUNT); }
      var t = text(drawer, TOTAL);
      if (t !== lastTotal) { lastTotal = t; bump(drawer, TOTAL); }
    }).observe(drawer, { attributes: true, attributeOldValue: true, attributeFilter: ['class'], childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
